import {
  radar_visualization,
  QUADRANT,
  RING,
  MOVED,
} from "./radar_visualization.js";
import { sheet } from "./sheet.js";

const quadrantsMap = {
  "Languages & Frameworks": QUADRANT.SouthEast,
  Platforms: QUADRANT.SouthWest,
  Techniques: QUADRANT.NorthWest,
  Tools: QUADRANT.NorthEast,
};

const ringsMap = {
  Adopt: RING.Innermost,
  Trial: RING.Inner,
  Assess: RING.Outer,
  Hold: RING.Outermost,
};

const movedMap = {
  no: MOVED.NotMoved,
  up: MOVED.MovedIn,
  down: MOVED.MovedOut,
};

const config = {
  svg_id: "radar",
  width: 1350,
  height: 1000,
  colors: {
    background: "#ebf0f5",
    grid: "#647383",
    inactive: "#ddd",
  },
  quadrants: Object.keys(quadrantsMap).map((name) => ({ name })),
  rings: [
    { name: "Adopt", color: "#008762" },
    { name: "Trial", color: "#d0491e" },
    { name: "Assess", color: "#ff6f40" },
    { name: "Hold", color: "#0079d2" },
  ],
  entries: [],
};

export function initializeRadar() {
  const mapSheetRow = (row) => {
    return {
      active: row[0] === "yes",
      moved: movedMap[row[1]] ?? MOVED.NotMoved,
      label: row[2],
      quadrant: quadrantsMap[row[3]] ?? QUADRANT.Unknown,
      ring: ringsMap[row[4]] ?? RING.Unknown,
    };
  };

  const removeEmptyItems = (v) => {
    return (
      v.active &&
      v.label &&
      v.quadrant !== QUADRANT.Unknown &&
      v.ring !== RING.Unknown
    );
  };

  sheet("radar")
    .then((result) => {
      return result.data.map(mapSheetRow).filter(removeEmptyItems);
    })
    .then((entries) => {
      radar_visualization({ ...config, entries });
    });
}
